import React, { useEffect, useMemo, useRef, useState } from 'react';
import { connect } from 'react-redux';

import { toggleModalWithTimer } from 'apps/auth/actions/appAction';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { PanelRightBlock, PanelRow } from 'apps/auth/components/common/Panel/styles';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import { Text } from 'apps/auth/components/common/Text/Text';
import ProfileNotificationsPopup from 'apps/auth/components/profile/notifications/ProfileNotificationsPopup';
import BasePage from 'apps/auth/components/utils/BasePage';
import { PROFILE_NOTIFICATION } from 'apps/auth/constants/formName';
import { AUTH_PROFILE_SETTINGS } from 'apps/auth/constants/UrlConstants';

const ProfileNotificationsPage = (props) => {
    const [isShowSuccessStatus, setIsShowSuccessStatus] = useState(false);
    const popupRef = useRef(null);

    useEffect(() => {
        if (!props.isShowSpinner && isShowSuccessStatus) {
            props.toggleModalWithTimer(true, props.modalSuccessTitle);
            setIsShowSuccessStatus(false);
        }
    }, [props.isShowSpinner]);

    const onSetIsShowSuccessStatus = () => setIsShowSuccessStatus(true);

    const textToShow = useMemo(() => {
        const subscriptions = {
            [props.subscribeMarketingEmailTitle]: props.subscribeMarketingEmail,
            [props.subscribeMarketingSmsTitle]: props.subscribeMarketingSms,
            [props.subscribeMarketingPushTitle]: props.subscribeMarketingPush,
        };
        const subscriptionsMap = Object.entries(subscriptions);
        const subscriptionsToShow = subscriptionsMap.filter(([, value]) => value);
        if (!subscriptionsToShow.length) {
            return '';
        }
        return subscriptionsToShow.length > 1 ? subscriptionsToShow.map(([title]) => title).join(', ') : subscriptionsToShow[0][0];
    }, [props.subscribeMarketingEmail, props.subscribeMarketingSms, props.subscribeMarketingPush]);

    return (
        <>
            <CommonPage backUrl={AUTH_PROFILE_SETTINGS}>
                <Row indent="16px">
                    <HeaderPanel title={props.headerTitle} subtitle={props.profileNotificationsInfo} />
                </Row>
                <Text variant="div" color="secondary" size="subheader" indent="24px">
                    {props.profileNotificationsMarketing}
                </Text>
                <Panel
                    type="button"
                    isHoverable
                    negativeMargin
                    justify="between"
                    onClick={() => {
                        popupRef.current?.open(
                            <ProfileNotificationsPopup
                                onSetIsShowSuccessStatus={onSetIsShowSuccessStatus}
                                title={props.profileNotificationsReceiveEmailTitle}
                                popupRef={popupRef}
                            />,
                        );
                    }}
                >
                    <PanelRow>
                        <PanelRow alignStart>
                            <Text>{props.profileNotificationsTransfersEmail}</Text>
                        </PanelRow>
                        <PanelRightBlock>
                            <Text color="secondary">{textToShow}</Text>
                        </PanelRightBlock>
                    </PanelRow>
                </Panel>
            </CommonPage>
            <PopupNew ref={popupRef} getPopupComponent={(component) => component} />
        </>
    );
};
const mapStateToProps = (state) => {
    const formFieldsInitValue = {
        subscribeMarketingEmail: { placeholder: '' },
        subscribeMarketingSms: { placeholder: '' },
        subscribeMarketingPush: { placeholder: '' },
    };

    const {
        profile_form = {
            subscribeMarketingEmail: false,
            subscribeMarketingSms: false,
            subscribeMarketingPush: false,
        },
    } = state.extra;
    const { fields = formFieldsInitValue } = state.form[PROFILE_NOTIFICATION];

    const {
        subscribeMarketingEmail: { placeholder: subscribeMarketingEmailTitle },
        subscribeMarketingSms: { placeholder: subscribeMarketingSmsTitle },
        subscribeMarketingPush: { placeholder: subscribeMarketingPushFullTitle },
    } = fields;
    const { subscribeMarketingEmail, subscribeMarketingSms, subscribeMarketingPush } = profile_form;

    const subscribeMarketingPushTitle = subscribeMarketingPushFullTitle.split(' ')[0];

    return {
        profileNotificationsTransfersEmail: state.messages.pageMessages.profileNotificationsTransfersEmail,
        profileNotificationsReceiveEmailTitle: state.messages.pageMessages.profileNotificationsReceiveEmailTitle,
        headerTitle: state.messages.pageMessages.headerTitle,
        profileNotificationsInfo: state.messages.pageMessages.profileNotificationsInfo,
        profileNotificationsMarketing: state.messages.pageMessages.profileNotificationsMarketing,
        modalSuccessTitle: state.messages.pageMessages.modalSuccessTitle,
        isShowSpinner: state.app.isShowSpinner,
        subscribeMarketingEmail,
        subscribeMarketingSms,
        subscribeMarketingPush,
        subscribeMarketingEmailTitle,
        subscribeMarketingSmsTitle,
        subscribeMarketingPushTitle,
    };
};
export default connect(mapStateToProps, { toggleModalWithTimer })(BasePage(ProfileNotificationsPage));
